import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { checkoutUrl } from '../data/landing';
type CtaButtonProps = {
  children: React.ReactNode;
  href?: string;
  size?: 'md' | 'lg';
  variant?: 'gold' | 'light';
  className?: string;
};
export function CtaButton({
  children,
  href = checkoutUrl,
  size = 'md',
  variant = 'gold',
  className = ''
}: CtaButtonProps) {
  const sizes = size === 'lg' ? 'px-8 py-5 text-base md:text-lg' : 'px-7 py-4 text-sm md:text-base';
  const variants = variant === 'gold' ? 'bg-gold text-white hover:bg-gold-dark focus-visible:ring-gold' : 'bg-gold-bright text-ink hover:bg-gold-soft focus-visible:ring-gold-bright';
  return <a href={href} className={`group inline-flex items-center justify-center gap-3 rounded-full font-black uppercase tracking-wide shadow-[0_10px_30px_-12px_rgba(139,100,33,0.6)] transition-[background-color,transform] duration-150 ease-out active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-cream text-center ${sizes} ${variants} ${className}`} data-id="element-40" data-mp="10c7rycmefvsm">
      <span data-id="element-41" data-mp="39yrd1a7e5mhf">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-42" data-mp="39xzmidsniey0" />
    </a>;
}